export const InitTooltips = (container = document) => {
    // Reset bestaande event listeners eerst
    const tooltipButtons = container.querySelectorAll('[data-toggle="tooltip"]');
    
    tooltipButtons.forEach(button => {
        // Clone button om alle bestaande event listeners te verwijderen
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        const tooltipId = newButton.getAttribute('data-target');
        const tooltip = document.getElementById(tooltipId);
        
        if (!tooltip) return;

        // Desktop: hover behavior
        newButton.addEventListener('mouseover', () => {
            tooltip.classList.remove('hidden');
        });
        
        newButton.addEventListener('mouseleave', () => {
            tooltip.classList.add('hidden');
        });

        // Mobile: click/touch behavior - gebruik zowel click als touchend
        const handleTooltipToggle = (e) => {
            // Don't prevent default if clicked on a stretched-link
            if (!e.target.closest('.stretched-link')) {
                e.preventDefault();
                e.stopPropagation();
            }
            
            const isHidden = tooltip.classList.contains('hidden');
            
            // Verberg alle andere tooltips eerst
            document.querySelectorAll('[data-toggle="tooltip"]').forEach(otherButton => {
                const otherTooltip = document.getElementById(otherButton.getAttribute('data-target'));
                if (otherTooltip && otherTooltip !== tooltip) {
                    otherTooltip.classList.add('hidden');
                }
            });
            
            // Toggle huidige tooltip
            if (isHidden) {
                tooltip.classList.remove('hidden');
            } else {
                tooltip.classList.add('hidden');
            }
        };
        
        // Voeg multiple event listeners toe voor betere mobile support
        newButton.addEventListener('click', handleTooltipToggle);
        newButton.addEventListener('touchend', handleTooltipToggle);
        
        // Zorg dat de button focusable is voor accessibility en debugging
        if (!newButton.hasAttribute('tabindex')) {
            newButton.setAttribute('tabindex', '0');
        }
        
        // Extra debugging: voeg een visuele indicator toe dat het clickable is
        newButton.style.cursor = 'pointer';
        newButton.style.userSelect = 'none';
    });
    
    // Klik buiten tooltip sluit alle tooltips (voor mobiel)
    document.addEventListener('click', (e) => {
        const isTooltipButton = e.target.closest('[data-toggle="tooltip"]');
        const isTooltip = e.target.closest('[id^="tooltip-content"]');
        
        if (!isTooltipButton && !isTooltip) {
            document.querySelectorAll('[id^="tooltip-content"]').forEach(tooltip => {
                tooltip.classList.add('hidden');
            });
        }
    });
};
